import { request } from '@/shared/api/request'

export const getQR = (externalId, action) => {
	return request({ url: `contract/mgov/getQRCode?externalId=${externalId}&action=${action}`, method: 'GET' })
}
